import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "pagination" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "«", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "<", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, ">", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "»", -1)
const _hoisted_10 = [
  _hoisted_9
]

import {computed} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Pagination',
  props: {
    maksSynligeKnapper: null,
    antalSider: null,
    perSide: null,
    side: null
  },
  emits: ["sideskift"],
  setup(__props: any, { emit }: { emit: ({
  (e: "sideskift", value: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  maksSynligeKnapper?: number;
  antalSider: number;
  perSide: number;
  side: number;
}





const antalKnapper = computed<number>(() => {
  return props.maksSynligeKnapper ? props.maksSynligeKnapper : Math.min(props.antalSider, 5);
})
const erISlutningen = computed<boolean>(() => {
  return (props.side + Math.ceil(antalKnapper.value/2)) > props.antalSider;
});
const erIStarten = computed<boolean>(() => {
  return (props.side - Math.ceil(antalKnapper.value/2)) < 1;
});
const startside = computed<number>(() => {
  if (erIStarten.value) {
    return 1;
  }
  if (erISlutningen.value) {
    return Math.max(props.antalSider - antalKnapper.value + 1, 1);
  }
  return props.side - Math.floor(antalKnapper.value/2);
});
const erPaaFoersteSide = computed<boolean>(() => {
  return props.side === 1;
});
const erPaaSidsteSide = computed<boolean>(() => {
  return props.side === props.antalSider;
});
const sider = computed<number[]>(() => {
  const liste: number[] = [];
  for (let s = startside.value;
       s<= Math.min(startside.value + antalKnapper.value -1, props.antalSider);
       s++
  ) {
    liste.push(s);
  }
  return liste;
});

function onKlikFoersteSide() {
  emit("sideskift", 1);
}
function onKlikForrigeSide() {
  emit("sideskift", props.side - 1);
}
function onKlikSide(side: number) {
  emit("sideskift", side);
}
function onKlikNaesteSide() {
  emit("sideskift", props.side + 1);
}
function onKlikSidsteSide() {
  emit("sideskift", props.antalSider);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", null, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", {
        class: _normalizeClass('page-item' + (_unref(erPaaFoersteSide) ? ' disabled' : ''))
      }, [
        _createElementVNode("a", {
          class: "page-link",
          onClick: onKlikFoersteSide
        }, _hoisted_3)
      ], 2),
      _createElementVNode("li", {
        class: _normalizeClass('page-item' + (_unref(erPaaFoersteSide) ? ' disabled' : ''))
      }, [
        _createElementVNode("a", {
          class: "page-link",
          onClick: onKlikForrigeSide
        }, _hoisted_5)
      ], 2),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sider), (sidenummer) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass('page-item' + (sidenummer === __props.side ? ' active' : '')),
          key: sidenummer
        }, [
          _createElementVNode("a", {
            class: "page-link",
            onClick: ($event: any) => (onKlikSide(sidenummer))
          }, _toDisplayString(sidenummer), 9, _hoisted_6)
        ], 2))
      }), 128)),
      _createElementVNode("li", {
        class: _normalizeClass('page-item' + (_unref(erPaaSidsteSide) ? ' disabled' : ''))
      }, [
        _createElementVNode("a", {
          class: "page-link",
          onClick: onKlikNaesteSide
        }, _hoisted_8)
      ], 2),
      _createElementVNode("li", {
        class: _normalizeClass('page-item' + (_unref(erPaaSidsteSide) ? ' disabled' : ''))
      }, [
        _createElementVNode("a", {
          class: "page-link",
          onClick: onKlikSidsteSide
        }, _hoisted_10)
      ], 2)
    ])
  ]))
}
}

})